import DefaultResetForm from '@/components/DefaultResetForm';
import { CustomTextField } from '@/components/Formik/CustomTextField';
import { useUser } from '@/contexts/AuthContext';
import { api } from '@/services/apiClient';
import { resetName } from '@/validators/resetUsersInfo';
import { FormikValues } from 'formik';
import { IModalSuccessData } from '.';

interface ResetName {
  onSuccess: (value: IModalSuccessData) => void;
  handleClose: () => void;
}

const ResetName = ({ onSuccess, handleClose }: ResetName) => {
  const { user, updateUserData } = useUser();

  const handleSubmitResetNameForm = async (values: FormikValues) => {
    const userUpdate = {
      cpf: user?.cpf,
      name: values?.name,
      email: user?.email,
      display_name: user.display_name,
      username: user?.username,
    };
    await api.put('/auth/users/me', userUpdate);

    onSuccess({
      isOpen: true,
      text: 'Seu nome foi alterado com sucesso!',
    });
    updateUserData(userUpdate);
  };

  return (
    <DefaultResetForm
      title="Informe seu nome"
      onSubmit={handleSubmitResetNameForm}
      handleCancel={handleClose}
      handleClose={handleClose}
      initialValues={{
        name: user.name,
      }}
      validationSchema={resetName}
    >
      <CustomTextField label="Nome *" name="name" variant="standard" />
    </DefaultResetForm>
  );
};

export default ResetName;
